const webDevelopment = [
  "JavaScript",
  "React",
  "CSS",
  "Angular",
  "Node.Js",
  "HTML 5",
  "PHP",
  "Django",
];
const dataScience = [
  "Python",
  "Machine Learning",
  "Deep Learning",
  "Data Analysis",
  "Artificial Intelligence",
  "R (programing language)",
  "Statistics",
  "Natural Language Processing",
];
const mobileDevelopment = [
  "Google Flutter",
  "Android Development",
  "iOS Development",
  "Dart (program language)",
  "Kotlin",
  "SwiftUI",
];
const programmingLanguages = [
  "Python",
  "Java",
  "C#",
  "React",
  "C++",
  "JavaScript",
  "C (programming language)",
  "Go (programming language)",
  "Solidity",
];
const gameDevelopment = [
  "Unity",
  "Unreal Engine",
  "Game Developmemt Fundamentals",
  "C#",
  "3D Game Development",
  "C++",
  "2D Game Development",
  "Unreal Engine Bluepronts",
  "Virtual Reality",
];
const dataDesignAndDevelopment = [
  "SQL",
  "MySQL",
  "Oracle SQL",
  "MongoDB",
  "Databasee Management",
  "Apache Kafka",
  "Oracle Certification",
  "Database Programming",
  "SQL Server",
];
const softwareTesting = [
  "Selenium WebDriver",
  "Java",
  "Automation Testing",
  "Selenium Testing Framework",
  "Postman",
  "Quality Assurance",
  "REST Assured",
];
const softwareEngineering = [
  "Data Structures",
  "Coding Interview",
  "Algorithms",
  "Kubernetes",
  "Certified Kubernetes Aoolication Developer (CKAD)",
  "Microsesrvices",
  "Software Architecture",
  "Python",
  "Blockchain",
];
const softwareDevelopmentTools = [
  "Docker",
  "Git",
  "Kubernetes",
  "DevOps",
  "JIRA",
  "Jenkinds",
  "Confluence",
  "Continuous Integration",
  "Node.Js",
];
const noCodeDevelopment = [
  "Elementor",
  "Bubble Visual Programming",
  "Artificial Intelligence",
  "Wix",
  "Web Design",
  "WordPress",
  "Microsoft PowerApps",
  "Airtable",
  "Pegasystems Certification",
];
const enterpreneurship = [
  "Business Fundamentals",
  "Entrepreneurship Fundamentals",
  "Freelancing",
  "Buisiness Strategy",
  "Startup",
  "Online Business",
  "Blogging",
  "Home Business",
];
const communication = [
  "Communication Skills",
  "Presentation Skills",
  "Public Speaking",
  "Writing",
  "Business Writing",
  "Fiction Writing",
  "Email Etiquette",
  "Storytelling",
  "Technical Writing",
];
const management = [
  "Product Management",
  "Leadership",
  "Management Skills",
  "BPM Business Process Management",
  "Business Strategy",
  "ISO 9001",
  "Project Management",
  "Manager Trainig",
  "PMP",
];
const sales = [
  "Sales Skills",
  "B2B Sales",
  "LinkedIn",
  "Presentation Skills",
  "Lead Generation",
  "Business Development",
  "Customer Success Management",
  "Cold Email",
  "Customer Service",
];
const businessStrategy = [
  "Digital Marketing",
  "Management Consulting",
  "TOGAF 9 Foundation",
  "Business Model",
  "TOGAF 9 Certified",
  "Innovation",
  "Digital Transformation",
  "Design Thinking",
];
const operations = [
  "Six Sigma",
  "Six Sigma Green Belt",
  "Six Sigma Yellow Belt",
  "Supply Chain",
  "Six Sigma Black Belt",
  "Quality Management",
  "Six Sigma White Belt",
  "Lean",
  "Logistics Management",
];
const projectManagement = [
  "PMP",
  "PMI PMBOK",
  "Scrum",
  "Agile",
  "CAPM Certified Associate in Project Management",
  "Professional Scrum Master (PSM)",
  "PMI-ACP",
  "Business Analysis",
];
const businessLaw = [
  "GDPR",
  "Law",
  "Contract Law",
  "Medical Device Development",
  "Contract Management",
  "Data Protection",
  "Healthcare IT",
  "Goods and Services Tax",
];
const businessAnalyticsAndIntelligence = [
  "Microsoft Power BI",
  "SQL",
  "Tableau",
  "Business Analysis",
  "Data Modeling",
  "Business Intelligence",
  "Blockchain",
  "MySQL",
  "Data Analysis",
];
const humanResources = [
  "Recruiting",
  "HR Analytics",
  "Instructional Design",
  "Hiring",
  "Emotional Intelligence",
  "Diversity and Inclusion",
  "Corporate Learning and Development (L&D)",
  "Employment Law",
];
const industry = [
  "Piping",
  "Trucking",
  "EPLAN Electric P8",
  "Chemical Engineering",
  "Electrical Engeering",
  "Salesforce",
  "Oil and Gas Industry",
  "Life Coach Training",
  "Freight Broker",
];
const eCommerce = [
  "Amazon FBA",
  "Dropshipping",
  "Shopify",
  "Shopify Dropshipping",
  "Selling on Amazon",
  "Etsy",
  "Passive Income",
  "WordPress",
];
const media = [
  "Audiobook Creation",
  "Podcasting",
  "Screenwriting",
  "Journalism",
  "Writing",
  "Amazon Kindle Direct Publishing (KDO)",
  "After Effects",
  "Motion Graphics",
  "Scrivener",
];
const realEstate = [
  "Real Estate Investing",
  "Airbnb Hosting",
  "Mortgage",
  "Notary Business",
  "Construction",
  "Financial Modeling",
  "Real Estate Marketing",
  "Property Management",
];
const otherBusiness = [
  "QuickBooks Online",
  "Grant Writing",
  "Transcription",
  "Data Entry Skills",
  "PowerPoint",
  "Bitcoin",
  "Freelance Writing",
  "Binance",
  "Fundrasing",
];
const accountingAndBookkeeping = [
  "Accounting",
  "Bookkeeping",
  "Financial Accounting",
  "Finance Fundamentals",
  "QuickBooks Online",
  "IFRS",
  "Financial Statement",
  "QuickBooks",
  "SAP FICO",
];
const compliance = [
  "Anti-Money Laundering",
  "CAMS Certification",
  "Risk Management",
  "Sarbanes-Oxley (SOX)",
  "IFRS",
  "Internal Auditing",
  "Fraud Analytics",
  "Trade and Commerce",
  "Accounting",
];
const cryptocurrencyAndBlockchain = [
  "Cryptocurrency",
  "NFT (Non-Fungible Tokens)",
  "Bitcoin",
  "Blockchain",
  "Binance",
  "Day Trading",
  "Metaverse",
  "Personal Finance",
  "Bitcoin Trading",
];
const econimics = [
  "Microeconomics",
  "Macroeconomics",
  "Stata",
  "Finance Fundamentals",
  "Econometrics",
  "Global Economics",
  "Entrepreneurship Fundamentals",
  "Regression Analysis",
];
const finance = [
  "Personal Finance",
  "Investment Banking",
  "CFA",
  "Finance Fundamentals",
  "Banking",
  "Finacial Analysis",
  "Financial Management",
  "Corporate Finance",
  "Company Valuation",
];
const financeCertAndExamPrep = [
  "CFA",
  "Certified Management Accountant (CMA)",
  "Financial Management",
  "ACCA",
  "ANBIMA Certification",
  "Quantitative Finance",
  "Financial Markets",
  "Stock Trading",
  "Fixed Income Securities",
];
const financialModelingAndAnalysis = [
  "Financial Analysis",
  "Financial Modeling",
  "Excel",
  "Finance Fundamentals",
  "Investment Banking",
  "Python",
  "Accounting",
  "Investing",
  "Financial Accounting",
];
const investingAndTrading = [
  "Stock Trading",
  "Investing",
  "Technical Analysis",
  "Forex",
  "Algorithmic Trading",
  "Day Trading",
  "Options Trading",
  "Financial Markets",
  "Cryptocurrency",
];
const moneyManagementTools = [
  "QuickBooks Online",
  "QuickBooks",
  "SAP FICO",
  "QuickBooks Pro",
  "Excel",
  "Xero",
  "Excel Analytics",
  "Financial Analysis",
  "SAP",
];
const taxes = [
  "Tax Preparation",
  "Accounting",
  "Goods and Services Tax",
  "Value Added Tax (VAT)",
  "Home Busicess",
  "Financial Accounting",
  "Entrepreneurship Fundamentals",
  "SAT",
  "Finance Fundamentals",
];
const otherFinanceAndAccounting = [
  "Technical Analysis",
  "PowerPoint",
  "Passive Income",
  "NFT (Non-Fungible Tokens)",
  "Financial Planning",
  "Personal Finance",
  "Finance Fundamentals",
  "Coaching",
  "Stock Trading",
];
const itCertifications = [
  "AWS Certification",
  "Microsoft Certification",
  "AWS Certified Solutions Architect - Associate",
  "AWS Certified Cloud Practitioner",
  "CompTIA A+",
  "Amazon AWS",
  "Cisco CCNA",
  "AWS Certified Developer - Associate",
  "Microsoft AZ-900",
];
const networkSecurity = [
  "Ethical Hacking",
  "Cyber Security",
  "Penetration Testing",
  "Network Security",
  "IT Networking Fundamentals",
  "CompTIA Network+",
  "Cisco CCNA",
  "Kubernetes",
  "CompTIZ Security+",
];
const hardware = [
  "Arduino",
  "PLC",
  "Electronics",
  "Embedded Systems",
  "Microcontroller",
  "Raspberry Pi",
  "Embedded C",
  "FPGA",
  "Siemens TIA Portal",
];
const operatingSystemAndService = [
  "Linux",
  "Linux Administration",
  "Windows Server",
  "Shell Scripting",
  "Active Directory",
  "PowerShell",
  "Linux Command Line",
  "macOS",
  "LPIC-1: Linux Administrator",
];
const otherITSoftware = [
  "Python",
  "DevOps",
  "NFT (Non-Fungible Tokens)",
  "Kubernetes",
  "Docker",
  "Algorithms",
  "SQL",
  "Software Architecture",
  "Ansible",
];
const microsoft = [
  "Excel",
  "Excel VBA",
  "Excel Formulas and Functions",
  "Microsoft Office",
  "PowerPoint",
  "Data Analysis",
  "Microsoft Power BI",
  "Pivot Tables",
  "Microsoft Word",
];
const apple = [
  "Mac Basics",
  "iMovie",
  "macOS",
  "Numbers For Mac",
  "Apple Keynote",
  "Mac Pages",
  "Microsoft Office 365",
  "Microsoft Word",
  "Apple Products Basics",
];
const google = [
  "Google Sheets",
  "Google Workspace (G Suite)",
  "Google Looker",
  "Google Data Studio",
  "Google Drive",
  "Gmail Productivity",
  "Google Docs",
  "Google AppSheet",
  "Virtual Assistant",
];
const sap = [
  "SAP ABAP",
  "SAP S/4HANA",
  "SAP SD",
  "SAP MM",
  "SAP HCM",
  "SAP Certified Application Associate - SAP S/4HANA",
  "SAP FICO",
  "SAP Financial Accounting",
];
const oracle = [
  "Oracle SQL",
  "PI/SQL",
  "Oracle Database",
  "Database Administration",
  "Oracle Certification",
  "Oracle Primavera",
  "Oracle E-Business Suite",
  "SQL",
  "Oracle Data Integrator",
];
const otherOfficeProductivity = [
  "ServiceNow",
  "Typing",
  "Python",
  "Time Management",
  "Programming Fundamentals",
  "QuickBooks Pro",
  "Construction Estimation",
  "AutpCAD",
  "Computer Skills",
];
const personalTransformation = [
  "Life Coash Training",
  "Neuro-Linguistic Programming",
  "Personal Development",
  "Life Purpose",
  "Mindfulness",
  "Meditation",
  "CBT Cognitive Behavioral Therapy",
  "Coaching",
];
const personalProductivity = [
  "Time Management",
  "Notion Workspace",
  "Speed Reading",
  "Focus Mastery",
  "Organization",
  "Procrastination",
  "Motivation",
  "Goal Setting",
];
const leadership = [
  "Management Skills",
  "Manager Trainig",
  "Communication Skills",
  "Conflict Management",
  "Public Speaking",
  "Listening Skills",
  "Relationship Building",
  "Coaching",
];
const cateerDevelopment = [
  "Resume and CV Writing",
  "Interviewing Skills",
  "Job Search",
  "Business Communication",
  "Business Writing",
  "Personal Networking",
  "LinkedIn",
  "Voice Acting",
];
const parentingAndPelationships = [
  "Parenting",
  "Relationship Building",
  "Child Psychology",
  "Love",
  "Couples Counseling",
  "Counseling",
  "Marriage",
  "Early Childhood Edcation",
  "Life Coach Trainig",
];
const happiness = [
  "Life Coach Training",
  "Positive Psychology",
  "Manifestation and Law of Attraction",
  "CBT Cognitive Behavioral Therapy",
  "Neuro-Linguistic Programming",
  "Childhood Trauma Healing",
  "Eye Movement Desensitization and Reprocessing (EMDR)",
  "Mindfulness",
];
const esotericPractices = [
  "Reiki",
  "Energy Healing",
  "Tarot Reading",
  "Psychic",
  "Hypotherapy",
  "Spiritual Healing",
  "Crystal Energy",
  "Chakra",
  "Astrology",
];
const religionAndSpirituality = [
  "Spirituality",
  "Mindfulness",
  "Life Coadh Training",
  "Tarot Reading",
  "Numerology",
  "Spiritual Healing",
  "Meditation",
  "Kabbalah",
  "Christianity",
];
const personalBrandAndBuilding = [
  "Personal Branding",
  "Business Communication",
  "Meetings",
  "Public Speaking",
  "Voice Trainig",
  "LinkedIn",
  "Writing a Book",
  "Communication Skills",
  "Personal Networking",
];
const creativity = [
  "Creative Writing",
  "Screenwriting",
  "Art Therapy",
  "Writing",
  "Writing a Book",
  "Storytelling",
  "Novel Writing",
  "Magic Trick",
];
const influence = [
  "Voice Training",
  "Communication Skills",
  "Public Speaking",
  "Negotiation",
  "Persuation",
  "Body Language",
  "Confidence",
  "Personal Development",
  "Psychology",
];
const selfEsteemAndConfidence = [
  "Confidence",
  "Self-Esteem",
  "Communication Skills",
  "Personal Development",
  "Dance",
  "Social Skills",
  "Fashion",
  "Anxiety Management",
  "Public Speaking",
];
const stressManagement = [
  "Emotional Intelligence",
  "Anxiety Management",
  "Anger Management",
  "Resilience",
  "EFT (Emotional Freedom Techniques)",
  "Master Your Emotions",
  "Fitness",
  "Mindfulness",
];
const memoryAndStudySkills = [
  "Memory",
  "Speed Reading",
  "Leaning Strategies",
  "Study Skills",
  "Focus Mastery",
  "Mind Mapping",
  "ADHD",
  "Learning Disability",
  "Personal Development",
];
const motivation = [
  "Neuroplasticity",
  "Procrastination",
  "Goal Setting",
  "Neuro-Linguistic Programming",
  "Habits",
  "Personal Success",
  "Confidence",
  "Goal Achievement",
];
const otherPersonalDevelopment = [
  "Freight Broker",
  "Public Speaking",
  "Meditation",
  "Car Repair",
  "Communication Skills",
  "Handwriting Analysis",
  "Electrical Writing",
  "Oil Painting",
  "Electricity",
];
const webDesign = [
  "WordPress",
  "Mobile App Design",
  "CSS",
  "HTML",
  "User Interface",
  "Photoshop",
  "HTML 5",
  "Adobe Xd",
];
const graphicDesignAndIllustration = [
  "Graphic Design",
  "Photoshop",
  "Adobe Illustrator",
  "Drawing",
  "Digital Painting",
  "Canva",
  "InDesign",
  "Character Design",
  "Design Theory",
];
const designTools = [
  "Procreate Digital Illustration App",
  "Photoshop",
  "After Effects",
  "Adobe Premiere",
  "Adobe Illustrator",
  "AutoCAD",
  "Digital Art",
  "Photoshop Retouching",
  "SOLIDWORKS",
];
const userExperienceDesign = [
  "User Interface",
  "Adobe XD",
  "Figma",
  "Product Design",
  "Design Thinking",
  "Web Design",
  "Mobile App Design",
  "Gamification",
];
const gameDesign = [
  "Unreal Engine",
  "Pixel Art",
  "Unity",
  "VFX Visual Effects",
  "Game Development Fundamentals",
  "Blender",
  "Digital Painting",
  "Drawing",
];
const threeDAnimation = [
  "Blender",
  "3D Modeling",
  "After Effects",
  "Motion Graphics",
  "3D Animation",
  "zBrush",
  "Fusion 360",
  "Animation",
  "Character Design",
];
const fashionDesign = [
  "Fashion",
  "Sewing",
  "Adobe Illustrator",
  "Jewely Design",
  "Photoshop",
  "Jewelry Making",
  "Textiles",
  "T-Shirt Design",
];
const architectualDesign = [
  "AutoCAD",
  "Revit",
  "Blander",
  "SketchUp",
  "LEED",
  "ARCHICAD",
  "3D Animation",
  "Landscape Architecture",
];
const interiorDesign = [
  "SketchUp",
  "Color Theory",
  "Lightning Design",
  "HVAC",
  "Electrical Engineering",
  "Minimalist Lifestyle",
  "Feng Shui",
  "Botany",
];
const otherDesign = [
  "Character Design",
  "Electronics",
  "Drawing",
  "PCB Design",
  "Comic Book Creation",
  "Perspective Drawing",
  "Digital Painting",
  "Geometric Dimensioning and Tolerancing (GD&T)",
  "Procreate Digital Illustration App",
];
const degitalMarketing = [
  "Social Media Marketing",
  "Marketing Strategy",
  "Internet Marketing",
  "Copywriting",
  "Google Analytics",
  "Email Marketing",
  "YouTube Marketing",
  "Podcasting",
];
const searchEngineOptimization = [
  "SEO",
  "WordPress",
  "Keyword Research",
  "Google My Business - Business Profile",
  "SEO Audit",
  "Local Building",
  "Link Building",
  "Shopify",
  "YouTube Audience Growth",
];
const socialMediaMarketing = [
  "Instagram Marketing",
  "Facebook Ads",
  "Facebook Marketing",
  "PPC Advertising",
  "TikTok Marketing",
  "Social Media Management",
  "LinkedIn",
  "Instagram Photography",
];
const branding = [
  "Business Branding",
  "YouTube Audience Growth",
  "YouTube Marketing",
  "Personal Branding",
  "Brand Management",
  "Marketing Strategy",
  "Customer Service",
  "Graphic Design",
  "Social Media Marketing",
];
const marketingFundamentals = [
  "Marketing Strategy",
  "Copywriting",
  "Marketing Plan",
  "Marketing Management",
  "Marketing Psychology",
  "Event Planning",
  "Coaching and Consulting Business",
  "Neuromarketing",
];
const marketingAnalyticsAndAutomation = [
  "Google Analytics",
  "Google Analytics Individual Qualification (IQ)",
  "Marketing Analytics",
  "Data Analysis",
  "Google Tag Manager",
  "Marketo",
  "Marketing Strategy",
  "SQL",
  "HubSpot",
];
const publicRelations = [
  "Communication Skills",
  "Media Training",
  "Business Communication",
  "Podcasting",
  "Writing",
  "Startup",
  "Presentaion Skills",
  "Public Speaking",
];
const paidAdvertising = [
  "Google Ads (AdWords)",
  "Google Ads (AdWords) Certification",
  "Facebook Ads",
  "Retargeting",
  "YouTube Marketing",
  "PPC Advertising",
  "Programmatic Advertising",
  "Email Marketing",
  "Mailchimp",
];
const videoAndMobileMarketing = [
  "YouTube Marketing",
  "YouTube Audience Growth",
  "Video Creation",
  "PowerPoint",
  "Video Editing",
  "Video Marketing",
  "App Marketing",
  "App Store Optimization",
  "Video Production",
];
const contentMarketing = [
  "Copywriting",
  "Content Writing",
  "Blogging",
  "Writing",
  "Content Creation",
  "Business Writing",
  "Technical Writing",
  "SEO",
];
const growthHacking = [
  "Digital Marketing",
  "Facebook Ads",
  "Marketing Strategy",
  "App Marketing",
  "Passive Income",
  "B2B Sales",
  "SEO",
  "Excel",
];
const affiliateMarketing = [
  "ClickBank",
  "Amazon Affilicate Marketing",
  "SEO",
  "CPA Marketing",
  "Push Notification",
  "AdSence",
  "Online Business",
  "WordPress",
];
const productMarketing = [
  "Marketing Plan",
  "SaaS",
  "Product Management",
  "Facebook Ads",
  "Marketing Management",
  "Self-Publishing",
  "Amazon Kindle Direct Publishing (KDP)",
  "Voice-Over",
  "Marketing Strategy",
];
const otherMarketing = [
  "Copywriting",
  "Conversion Rate Optimization",
  "Event Planning",
  "NFT (Non-Fungible Tokens)",
  "Marketing Strategy",
  "YouTube Audience Growth",
  "A/B Testing",
  "Customer Experience Management",
  "Digital Marketing",
];
const artsAndCrafts = [
  "Drawing",
  "Watercolor Painting",
  "Pencil Drawing",
  "Sketching",
  "Figure Drawing",
  "Portraiture",
  "Acrylic Painting",
  "Procreate Digital Illustration App",
];
const beautyAndMakeup = [
  "Makeup Artistry",
  "Beauty",
  "Skincare",
  "Nail Art",
  "Cosmetics",
  "Hair Styling",
  "Perfume",
  "Facial Massage",
  "Tattoo Art",
];
const foodAndBeverage = [
  "Cooking",
  "Baking",
  "Cake Baking",
  "Coffee",
  "Bread Baking",
  "Wine Appreciation and Oenology",
  "Bartending",
  "Sourdough Bread Baking",
  "Cookie Baking",
];
const gaming = [
  "Chess",
  "Poker",
  "eSports",
  "Twitch",
  "League of Legends",
  "Open Broadcaster",
  "Character Design",
  "Rubik's Cube",
];
const homeImprovementAndGardening = [
  "Electricity",
  "Electrical Writing",
  "Home Repair",
  "Gardening",
  "Permaculture",
  "Farming",
  "Beekeeping",
  "Garden Design",
  "Hydroponics",
];
const petCareAndTraining = [
  "Dog Training",
  "Dog Behavior",
  "Dog Care",
  "Pet Care",
  "Pet Training",
  "Horsemanship",
  "Cat Behavior",
  "Animal Nutrition",
  "Acupressure",
];
const travel = [
  "Travel Tips",
  "Travel Writing",
  "Airbnb Hosting",
  "Travel Hacking",
  "Digital Nomad",
  "Writing",
  "Journaling",
  "iMovie",
  "Mac Bacics",
];
const otherLifestyle = [
  "Neuro-Linguistic Programming",
  "EFT (Emotional Freedom Techniques)",
  "Meditation",
  "Herbalism",
  "Emotional Intelligence",
  "Life Coach Training",
  "Mindfluness",
  "Aromatherapy",
  "CBT Cognitive Behaviral Therapy",
];
const digitalPhotography = [
  "Photography",
  "iPhone Photography",
  "Digital Camera Functionality",
  "Adobe Lightroom",
  "Mobile Photography",
  "Affinity Photo",
  "Photoshop",
  "Night Photography",
];
const photography = [
  "Digital Photography",
  "Photography Composition",
  "Affinity Photo",
  "Food Photography",
  "Mobile Photography",
  "Digital Camera Functionality",
  "Product Photography",
  "Landscape Photography",
];
const portraitPhotography = [
  "Posing",
  "Photography",
  "Photography Lighting",
  "Photoshop Retouching",
  "Family Portrait Photography",
  "Photoshop",
  "Flash Photography",
  "Photography Business",
];
const photographyTools = [
  "Adobe Lightroom",
  "Photoshop",
  "Image Editing",
  "Photoshop Retouching",
  "Affinity Photo",
  "Digital Camera Functionality",
  "Photography",
  "Drone and Aerial Photography",
  "GIMP",
];
const commercialPhotography = [
  "Real Estate Photography",
  "Architecture Photography",
  "Product Photography",
  "Photography Business",
  "Wedding Photography",
  "Photoshop Retouching",
  "Food Photography",
  "Marketing Strategy",
  "Photography",
];
const videoDesign = [
  "Video Editing",
  "Adobe Premiere",
  "Video Production",
  "Filmmaking",
  "DaVinci Resolve",
  "Color Grading",
  "Final Cut Pro",
  "Cinematography",
  "Videography",
];
const otherPhotographyAndVideo = [
  "Photography",
  "Drone and Aerial Photography",
  "Landscape Photography",
  "Nature Photography",
  "3D Modeling",
  "YouTube Audience Growth",
  "Filmmaking",
  "iPhone Photography",
  "Video Editing",
];
const fitness = [
  "Pilates",
  "Home Workout",
  "Muscle Building",
  "Teacher Trainig",
  "Testosterone",
  "Stretching Exercise",
  "Posture",
  "Wright Loss",
];
const generalHealth = [
  "Herbalism",
  "Holistic Medicine",
  "Message",
  "Aromatherapy",
  "Natural Medicine",
  "Health",
  "Acupressure",
  "Breathing Techniques",
  "Reflexology",
];
const sports = [
  "Soccer",
  "Sport Psychology",
  "Sports Coaching",
  "Tennis",
  "Swimming",
  "Sports Message",
  "Golf",
  "Sports Message",
  "Golf",
  "Sports Management",
  "Qi Gong",
];
const nutritionAndDiet = [
  "Nutrition",
  "Dieting",
  "Wright Loss",
  "Health Coaching",
  "Sports Nutrition",
  "Ketogenic Diet",
  "Vegan Cooking",
  "Gut Health",
  "Herbalism",
];
const yoga = [
  "Yoga for Kids",
  "Pranayama",
  "Face Yoga",
  "Chair Yoga",
  "Prenatal Yoga",
  "Kundalini",
  "Teacher Training",
  "Empowerment",
];
const mentalHealth = [
  "CBT Cognitive Behavioral Therapy",
  "Art Therapy",
  "Dialectical Behavior Theraphy (DBT)",
  "Psychotheraphy",
  "REBT",
  "Counseling",
  "Anxiety Management",
  "ADHD",
];
const martialArtsAndSelfDefense = [
  "Krav Maga",
  "Self-Defense",
  "Martial Arts",
  "Close Combat",
  "Tai Chi",
  "Boxing",
  "Brazillian Jiu-Jitsu",
  "Kung Fu",
  "Wing Chun",
];
const safetyAndFirstAid = [
  "First Aid",
  "Workplace Health and Safety",
  "Nutsing",
  "Health",
  "Health Coaching",
  "Herbalism",
  "OSHA",
  "Survival Skills",
  "Grief Healing",
];
const dance = [
  "Belly Dancing",
  "Salsa Dancing",
  "Bachata",
  "Tango Dance",
  "Hop Hop Dancing",
  "Poi Spinning",
  "Ballet",
  "Street Dance",
];
const meditation = [
  "Mindfulness",
  "Sound Therapy",
  "Qi Gong",
  "Reiki",
  "Breathing Techniques",
  "Tai Chi",
  "Yoga",
  "Energy Healing",
];
const otherHealthFitness = [
  "Massage",
  "Sports Massage",
  "Qi Gong",
  "Holistic Medicine",
  "Spiritual Healing",
  "EFT (Emotional Freedom Techniques)",
  "Facial Massage",
  "Energy Healing",
  "Medical Terminology",
];
const instruments = [
  "Piano",
  "Guiter",
  "Keyboard Instrument",
  "Ukulele",
  "Drums",
  "Bass Guitar",
  "Rock Guitar",
  "Violin",
  "Harmonica",
];
const musicProduction = [
  "Logic Pro X",
  "Music Mixing",
  "Ableton Live",
  "Music Composition",
  "FL Studio",
  "Game Music",
  "Audio Production",
  "Audio Engineering",
];
const musicFundamentals = [
  "Music Theory",
  "Music Composition",
  "Songwriting",
  "Electronic Music",
  "Reading Music",
  "Ear Training",
  "Piano",
  "Piano Chorids",
  "ABRSM",
];
const vocal = [
  "Singing",
  "Voice Training",
  "Voice Acting",
  "Rega Music",
  "Rapping",
  "Yoga",
  "Breathing Techniques",
  "Mindset",
  "coaching",
];
const musicTechniques = [
  "Fingerstyle Guitar",
  "Blues Guitar",
  "Music Composition",
  "Guitar",
  "Reading Music",
  "Piano",
  "Music Theory",
  "DJ",
  "Acoustic Guitar",
];
const musicSoftware = [
  "FL Studio",
  "Logic Pro X",
  "Ableton Live",
  "Music Production",
  "GarageBand",
  "Cubase",
  "DJ",
  "Pro Tools",
  "Audacity Software",
];
const otherMusic = [
  "DJ",
  "Songwriting",
  "Music Marketing",
  "Music Business",
  "Rapping",
  "Sound Therapy",
  "Luthiery",
  "Djembe",
  "Drums",
];
const engineering = [
  "Electrical Engineering",
  "Electronics",
  "Civil Engineering",
  "Solar Energy",
  "Mechanical Engineering",
  "Robotics",
  "Control Systems",
  "Aerospace Engineering",
  "Automotive Engineering",
];
const humanities = [
  "The Bible",
  "Christianity",
  "Philosophy",
  "Critical Thinking",
  "Art History",
  "Creative Writing",
  "Statistics",
  "English Literature",
  "History",
];
const math = [
  "Calculus",
  "Statistics",
  "Linear Algebra",
  "Algebra",
  "Probability",
  "Discrete Math",
  "Trigonometry",
  "Geometry",
];
const science = [
  "Physics",
  "Solar Energy",
  "Chemistry",
  "Orthodontics",
  "Biology",
  "Anatomy",
  "AP Physics",
  "Research Paper Writing",
  "Physiology",
];
const onlineEducation = [
  "Online Course Creation",
  "Teaching Online",
  "Canva",
  "Online Business",
  "Instruction Design",
  "Passive Income",
  "Moodle",
  "Adobe Captivate",
  "Articulate Storyline",
];
const socialScience = [
  "Phychology",
  "Counseling",
  "Psychotherapy",
  "Criminology",
  "Economics",
  "Critical Thinking",
  "Research Methods",
  "Forensic Science",
  "Social Psychology",
];
const languagelearning = [
  "English Language",
  "German Language",
  "Spanish Language",
  "English Grammar",
  "English Conversation",
  "Franch Language",
  "Japanese Language",
  "English Vocabulary",
  "Korean Language",
];
const teacherTraining = [
  "Train the Trainer",
  "Instructional Design",
  "Voice-Over",
  "Early Childhood Education",
  "Coaching",
  "ESL",
  "Health Coaching",
  "Life Coach Training",
];
const testPrep = [
  "IELTS",
  "TOEFL",
  "PMP",
  "English Language",
  "Bookkeeping",
  "PMI PMBOK",
  "Math",
  "CAPM Certified Associate in Project Management",
  "GMAT",
];
const otherTeachingAndAcademics = [
  "Microsoft Word",
  "Proofreading",
  "Research Methods",
  "Academic Writing",
  "Research Paper Writing",
  "Pet Training",
  "Puntuation",
  "Fiction Writing",
  "Early Chilhood Education",
];
export const subSubCategories = [
  {
    id: "c1s1",
    categories: webDevelopment,
  },
  {
    id: "c1s2",
    categories: dataScience,
  },
  {
    id: "c1s3",
    categories: mobileDevelopment,
  },
  {
    id: "c1s4",
    categories: programmingLanguages,
  },
  {
    id: "c1s5",
    categories: gameDevelopment,
  },
  {
    id: "c1s6",
    categories: dataDesignAndDevelopment,
  },
  {
    id: "c1s7",
    categories: softwareTesting,
  },
  {
    id: "c1s8",
    categories: softwareEngineering,
  },
  {
    id: "c1s9",
    categories: softwareDevelopmentTools,
  },
  {
    id: "c1s10",
    categories: noCodeDevelopment,
  },
  {
    id: "c2s1",
    categories: enterpreneurship,
  },
  {
    id: "c2s2",
    categories: communication,
  },
  {
    id: "c2s3",
    categories: management,
  },
  {
    id: "c2s4",
    categories: sales,
  },
  {
    id: "c2s5",
    categories: businessStrategy,
  },
  {
    id: "c2s6",
    categories: operations,
  },
  {
    id: "c2s7",
    categories: projectManagement,
  },
  {
    id: "c2s8",
    categories: businessLaw,
  },
  {
    id: "c2s9",
    categories: businessAnalyticsAndIntelligence,
  },
  {
    id: "c2s10",
    categories: humanResources,
  },
  {
    id: "c2s11",
    categories: industry,
  },
  {
    id: "c2s12",
    categories: eCommerce,
  },
  {
    id: "c2s13",
    categories: media,
  },
  {
    id: "c2s14",
    categories: realEstate,
  },
  {
    id: "c2s15",
    categories: otherBusiness,
  },
  {
    id: "c3s1",
    categories: accountingAndBookkeeping,
  },
  {
    id: "c3s2",
    categories: compliance,
  },
  {
    id: "c3s3",
    categories: cryptocurrencyAndBlockchain,
  },
  {
    id: "c3s4",
    categories: econimics,
  },
  {
    id: "c3s5",
    categories: finance,
  },
  {
    id: "c3s6",
    categories: financeCertAndExamPrep,
  },
  {
    id: "c3s7",
    categories: financialModelingAndAnalysis,
  },
  {
    id: "c3s8",
    categories: investingAndTrading,
  },
  {
    id: "c3s9",
    categories: moneyManagementTools,
  },
  {
    id: "c3s10",
    categories: taxes,
  },
  {
    id: "c3s11",
    categories: otherFinanceAndAccounting,
  },
  {
    id: "c4s1",
    categories: itCertifications,
  },
  {
    id: "c4s2",
    categories: networkSecurity,
  },
  {
    id: "c4s3",
    categories: hardware,
  },
  {
    id: "c4s4",
    categories: operatingSystemAndService,
  },
  {
    id: "c4s5",
    categories: otherITSoftware,
  },
  {
    id: "c5s1",
    categories: microsoft,
  },
  {
    id: "c5s2",
    categories: apple,
  },
  {
    id: "c5s3",
    categories: google,
  },
  {
    id: "c5s4",
    categories: sap,
  },
  {
    id: "c5s5",
    categories: oracle,
  },
  {
    id: "c5s6",
    categories: otherOfficeProductivity,
  },
  {
    id: "c6s1",
    categories: personalTransformation,
  },
  {
    id: "c6s2",
    categories: personalProductivity,
  },
  {
    id: "c6s3",
    categories: leadership,
  },
  {
    id: "c6s4",
    categories: cateerDevelopment,
  },
  {
    id: "c6s5",
    categories: parentingAndPelationships,
  },
  {
    id: "c6s6",
    categories: happiness,
  },
  {
    id: "c6s7",
    categories: esotericPractices,
  },
  {
    id: "c6s8",
    categories: religionAndSpirituality,
  },
  {
    id: "c6s9",
    categories: personalBrandAndBuilding,
  },
  {
    id: "c6s10",
    categories: creativity,
  },
  {
    id: "c6s11",
    categories: influence,
  },
  {
    id: "c6s12",
    categories: selfEsteemAndConfidence,
  },
  {
    id: "c6s13",
    categories: stressManagement,
  },
  {
    id: "c6s14",
    categories: memoryAndStudySkills,
  },
  {
    id: "c6s15",
    categories: motivation,
  },
  {
    id: "c6s16",
    categories: otherPersonalDevelopment,
  },
  {
    id: "c7s1",
    categories: webDesign,
  },
  {
    id: "c7s2",
    categories: graphicDesignAndIllustration,
  },
  {
    id: "c7s3",
    categories: designTools,
  },
  {
    id: "c7s4",
    categories: userExperienceDesign,
  },
  {
    id: "c7s5",
    categories: gameDesign,
  },
  {
    id: "c7s6",
    categories: threeDAnimation,
  },
  {
    id: "c7s7",
    categories: fashionDesign,
  },
  {
    id: "c7s8",
    categories: architectualDesign,
  },
  {
    id: "c7s9",
    categories: interiorDesign,
  },
  {
    id: "c7s10",
    categories: otherDesign,
  },
  {
    id: "c8s1",
    categories: degitalMarketing,
  },
  {
    id: "c8s2",
    categories: searchEngineOptimization,
  },
  {
    id: "c8s3",
    categories: socialMediaMarketing,
  },
  {
    id: "c8s4",
    categories: branding,
  },
  {
    id: "c8s5",
    categories: marketingFundamentals,
  },
  {
    id: "c8s6",
    categories: marketingAnalyticsAndAutomation,
  },
  {
    id: "c8s7",
    categories: publicRelations,
  },
  {
    id: "c8s8",
    categories: paidAdvertising,
  },
  {
    id: "c8s9",
    categories: videoAndMobileMarketing,
  },
  {
    id: "c8s10",
    categories: contentMarketing,
  },
  {
    id: "c8s11",
    categories: growthHacking,
  },
  {
    id: "c8s12",
    categories: affiliateMarketing,
  },
  {
    id: "c8s13",
    categories: productMarketing,
  },
  {
    id: "c8s14",
    categories: otherMarketing,
  },
  {
    id: "c9s1",
    categories: artsAndCrafts,
  },
  {
    id: "c9s2",
    categories: beautyAndMakeup,
  },
  {
    id: "c9s3",
    categories: esotericPractices,
  },
  {
    id: "c9s4",
    categories: foodAndBeverage,
  },
  {
    id: "c9s5",
    categories: gaming,
  },
  {
    id: "c9s6",
    categories: homeImprovementAndGardening,
  },
  {
    id: "c9s7",
    categories: petCareAndTraining,
  },
  {
    id: "c9s8",
    categories: travel,
  },
  {
    id: "c9s9",
    categories: otherLifestyle,
  },
  {
    id: "c10s1",
    categories: digitalPhotography,
  },
  {
    id: "c10s2",
    categories: photography,
  },
  {
    id: "c10s3",
    categories: portraitPhotography,
  },
  {
    id: "c10s4",
    categories: photographyTools,
  },
  {
    id: "c10s5",
    categories: commercialPhotography,
  },
  {
    id: "c10s6",
    categories: videoDesign,
  },
  {
    id: "c10s7",
    categories: otherPhotographyAndVideo,
  },
  {
    id: "c11s1",
    categories: fitness,
  },
  {
    id: "c11s2",
    categories: generalHealth,
  },
  {
    id: "c11s3",
    categories: sports,
  },
  {
    id: "c11s4",
    categories: nutritionAndDiet,
  },
  {
    id: "c11s5",
    categories: yoga,
  },
  {
    id: "c11s6",
    categories: mentalHealth,
  },
  {
    id: "c11s7",
    categories: martialArtsAndSelfDefense,
  },
  {
    id: "c11s8",
    categories: safetyAndFirstAid,
  },
  {
    id: "c11s9",
    categories: dance,
  },
  {
    id: "c11s10",
    categories: meditation,
  },
  {
    id: "c11s11",
    categories: otherHealthFitness,
  },
  {
    id: "c12s1",
    categories: instruments,
  },
  {
    id: "c12s2",
    categories: musicProduction,
  },
  {
    id: "c12s3",
    categories: musicFundamentals,
  },
  {
    id: "c12s4",
    categories: vocal,
  },
  {
    id: "c12s5",
    categories: musicTechniques,
  },
  {
    id: "c12s6",
    categories: musicSoftware,
  },
  {
    id: "c12s7",
    categories: otherMusic,
  },
  {
    id: "c13s1",
    categories: engineering,
  },
  {
    id: "c13s2",
    categories: humanities,
  },
  {
    id: "c13s3",
    categories: math,
  },
  {
    id: "c13s4",
    categories: science,
  },
  {
    id: "c13s5",
    categories: onlineEducation,
  },
  {
    id: "c13s6",
    categories: socialScience,
  },
  {
    id: "c13s7",
    categories: languagelearning,
  },
  {
    id: "c13s8",
    categories: teacherTraining,
  },
  {
    id: "c13s9",
    categories: testPrep,
  },
  {
    id: "c13s10",
    categories: otherTeachingAndAcademics,
  },
];
